module.exports = __webpack_public_path__ + "img/worlds-fair.019de420.webp";